import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
// import ReactTable from "react-table"
import DatePicker from "react-datepicker";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu

class ProviderAdvice extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };

        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchNotesApi()
                this.dialogClose();
                this.setState({
                })
            }
        }];


        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteNotesApi(this.state.id)

                this.state.hideDeleteSuccessPopup = true

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];
        this.state = {
            selectedValidTill: new Date(),
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            editedId: 0,
            providerAdvice: ''

        }

    }
    componentDidMount() {
        setTimeout(() => {
            this.fetchNotesApi();
        }, 0);

        var thisController = this;

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchNotesApi();
        });

    }
    editContent = event => {
        this.setState({ editedId: "-1" });
        document.getElementById('notes').readOnly = false;
    }

    showPopup = () => {
        this.setState({
            hideDeletePopup: true
        })
    }
    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b ><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the data</b>, {
            position: "top-center"
        });

    }

    notifyImproperNotes() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Please enter a valid note. Kindly avoid special charaters.
        </b>, {
            position: "top-center",
        });
    }




    saveNotesApi = (props) => {
        let addController = this;
        var notesPattern = new RegExp(/^([a-zA-Z0-9.%*&,/\s])*$/);
        if (!notesPattern.test(document.getElementById('notes').value) || document.getElementById('notes').value == "") {
            addController.notifyImproperNotes();
        } else {
            var data = {
                validTill: document.getElementById('validTill').value,
                patientId: localStorage.getItem('patientId'),
                notes: document.getElementById('notes').value
            }
            $.ajax({
                url: "/my-jeeva-api/provider-advice",
                
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'

                },
                data: JSON.stringify(data),

                success: function (res) {
                    if (res.success === true) {
                        // addController.notifyAdd();
                        addController.fetchNotesApi();
                        addController.state.editedId = 0;
                        addController.setState(addController.state);

                    } else {
                        // addController.notifyError(res.result);
                    }
                },

                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/";
                    }
                }
            });
        }
    }




    notifyAdd() {
        toast.dismiss();
        toast(<b ><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Notes Added Successfully</b>, {
            position: "top-center",

        });
    }

    notifyError(response) {
        toast.dismiss();
        toast(<b ><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
    }


    fetchNotesApi = () => {

        var fetchNotesController = this;
        $.ajax({
            url: "/my-jeeva-api/provider-advice",
            
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            }, data: {
                validTill: document.getElementById('validTill').value,
                patientId: localStorage.getItem('patientId')
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        fetchNotesController.state.editedId = 0;
                        var validTill = res.result.validTill;
                        var dateParts = validTill.split("/");
                        var validTillObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

                        fetchNotesController.state.selectedValidTill = validTillObj;
                        document.getElementById('notes').value = res.result.notes;
                        fetchNotesController.state.providerAdvice = res.result.notes;

                        document.getElementById('notes').readOnly = true;
                        fetchNotesController.state.id = res.result.id;
                        fetchNotesController.setState(fetchNotesController.state);
                    } else {
                        fetchNotesController.state.validTill = '';
                        document.getElementById('notes').value = '';
                        fetchNotesController.state.providerAdvice = '';
                        fetchNotesController.setState(fetchNotesController.state);

                    }
                }
                else {
                    // fetchNotesController.notifyError(res.result);
                }
            }
        });
    }



    deleteNotesApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteConstructorVariables.notifyError("No Data Found")
        } else {
            $.ajax({
                url: "/api/delete-provider-notes/" + id,
                
                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.fetchNotesApi();
                        deleteConstructorVariables.state.editedId = 0;
                        deleteConstructorVariables.setState(deleteConstructorVariables.state);
                        // deleteConstructorVariables.notifyDelete();
                    } else {
                        deleteRowViewController.NotifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/";
                    }
                }
            });
        }


    }


    notifyDelete() {
        toast.dismiss();
        toast(<b ><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notes Deleted Successfully</b>, {
            position: "top-center",

        });
    }
    onChangeValidTillDate = date => {

        // const selectedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
        // document.getElementById('validTill').value = selectedDate;
        this.state.selectedValidTill = date;
        this.setState(this.state);
        this.fetchNotesApi();
    }


    openDeletePopUp = (id) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: 'Are you sure to delete this? ',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteNotesApi(id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }


    render() {
        return (
            <div>

                <div style={{ background: 'rgb(249, 249, 251)' }} id='providerAdvise'>
                    {/* for email-css */}
                    <link rel="stylesheet" href="assets/css/scheduleReportStyle.css" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="stylesheet" href="./assets/css/styles.css" />

                    <div className="content-header">
                        <h6 className="nav-item" style={{ color: '#282a65' }}></h6>
                    </div>


                    <div className="card-body p-0 mb-25">
                        <div className="tab-content col-12 p-0">
                            <div className="tab-pane active show" id="tab_1">
                                <div className="card card-primary mt-3">
                                    <form role="form" className="raiseTicketLable">
                                        <div className="card-body raise-form">
                                            <div className="row">
                                                <div className="col-sm-1.5">

                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-10">

                                                </div>
                                                <div className="col-sm-2" Align='right'   >
                                                    <button type="button" className="btn btn-primary"
                                                        onClick={this.editContent}
                                                        style={{
                                                            fontFamily: 'inherit',
                                                            marginTop: '24px', width: '66px',
                                                            backgroundColor: '#282a65', color: 'white'
                                                        }}>Edit</button>


                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6" Align="left">
                                                    <div className="form-group">
                                                        <label style={{ marginRight: '1vw', fontSize: '14px', color: '#282A65', fontFamily: 'inherit' }}>Valid Till</label>
                                                        <DatePicker
                                                            style={{
                                                                width: '10px',
                                                                // marginLeft: '70%',
                                                                cursor: "pointer"
                                                            }}
                                                            autoOk={true}
                                                            id="validTill"
                                                            selected={this.state.selectedValidTill}
                                                            onChange={this.onChangeValidTillDate}
                                                            dateFormat="MM/dd/yyyy">
                                                        </DatePicker>
                                                    </div>

                                                </div></div>
                                            <div className='row'>

                                                <textarea placeholder='Write your notes here...'
                                                    style={{

                                                        //display: this.state.voiceProgressBar ? 'block' : 'none',
                                                        background: 'white', resize: 'none', height: "67px",
                                                        fontSize: "0.891em", marginTop: '3vw'
                                                    }}
                                                    id='notes'
                                                    className="form-control"
                                                    //value={this.state.providerAdvice}
                                                    contentEditable={true}
                                                // value={this.state.voiceStatus != null ? "Status : " + voiceStatus + '\n' + "Details : "
                                                //     + this.state.details : ""}
                                                />
                                            </div>
                                            <div>
                                                <div>
                                                    <button type="button" className="btn btn-primary pull-right navyblue-btn"
                                                        hidden={(this.state.editedId == 0) ? true : false}

                                                        onClick={this.openDeletePopUp(this.state.editedId)}
                                                        style={{ fontFamily: 'inherit', marginTop: '24px', width: '70px', marginRight: "-80px" }}
                                                    >Delete</button>
                                                </div>
                                                <div>
                                                    <button type="button" className="btn btn-primary pull-right navyblue-btn"
                                                        hidden={(this.state.editedId == 0) ? true : false}
                                                        onClick={this.saveNotesApi} style={{ fontFamily: 'inherit', marginTop: '24px', width: '66px' }}>Save</button>
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        </div>
                                        <ToastContainer className="Toast-at-center" />


                                        {/* Dialog Component For Deletion Confirmation */}
                                        {/* <DialogComponent width='400px' animationSettings={this.settings}
                                            header='Notes' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog} target='#providerAdvise'
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the Notes?<br />Note: Press 'Yes' to delete or press 'No' to decline.


                                        </DialogComponent> */}


                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default ProviderAdvice;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ProviderAdvice.js